import { TCustomFieldList } from '../../custom-fields/custom-fields.model';

export function findPositionPath(
  idToFind: string,
  list: TCustomFieldList[] | undefined,
  currentPath: number[] = [],
): number[] | null {
  if (!list) {
    return null;
  }
  for (let index = 0; index < list.length; index++) {
    const item = list[index];
    const path = [...currentPath, index];
    if (item.id === idToFind) {
      return path;
    }
    const nested = findPositionPath(idToFind, item.subList, path);
    if (nested) {
      return nested;
    }
  }
  return null;
}
